import { useState } from 'react'
import { Safety } from '../classes/Safety'
import { User } from '../types/models'

/**
 * A pass through hook to store and retrieve user information from the local storage.
 */
export const useUser = (): [user: User, setUser: (user: User | null) => void] => {
  const [user, _setUser] = useState<User|null>(Safety.get('user', null))

  const setUser = (user: User | null) => {
    Safety.set('user', user || undefined)
    _setUser(user)
  }

  return [user as User, setUser]
}
